// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ec2a5fc3","161":"1d8a1363","239":"e39fb35b","455":"6f739d8a","977":"9d626833"}[chunkId] + ".chunk.js";
};